const BUSINESS_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

export const LEAD_MESSAGE =
  "Hola, gracias por contactar Mi Protección 365 . Para atenderte más rápido, abre nuestra web y elige el servicio (Taxes / Salud / Auto).";

const VISITOR_MESSAGE =
  "Hola, me interesa una cotización gratis de seguro IUL y el bono de $50 para seguro de auto.";

// Normaliza a formato internacional sin "+": 10 dígitos => +1 (EE. UU.)
export const toWaDigits = (phone) => {
  const d = String(phone).replace(/\D/g, "");
  return d.length === 10 ? `1${d}` : d;
};

export const waLink = (phone, message) =>
  `https://wa.me/${toWaDigits(phone)}?text=${encodeURIComponent(message)}`;

export const businessWaLink = () => waLink(BUSINESS_NUMBER, VISITOR_MESSAGE);
export const leadWaLink = (lead) => waLink(lead.telefono, LEAD_MESSAGE);

export const formatBusinessNumber = () => {
  const d = String(BUSINESS_NUMBER || "");
  return d.length === 11 ? `+${d[0]} (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}` : `+${d}`;
};

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.6 1.9 6.5L4 29l7.8-2c1.8 1 3.9 1.5 6.1 1.5 6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.6c-1.9 0-3.8-.5-5.4-1.5l-.4-.2-4 1 1.1-3.9-.3-.4c-1.1-1.7-1.7-3.6-1.7-5.6 0-5.4 4.8-9.9 10.7-9.9s10.7 4.5 10.7 9.9-4.8 10.6-10.7 10.6zm5.9-7.4c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6-.1-.2-.7-1.8-1-2.4-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5 .8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.6.3-.8.3-1.4.2-1.6-.1-.1-.3-.2-.6-.4z" />
  </svg>
);
